export function shouldRunUseEffect(
  country: string,
  input: string = '',
  storeValue: string = ''
): boolean {
  if (storeValue) {
    return (
      input !== '' &&
      input.trim() === storeValue.trim() &&
      country === 'US'
    );
  }

  return country === 'US' && input !== '';
}